import {
  CREDIT_TOPUP_CAP_COP,
  CREDIT_TOPUP_MAX_PRESETS,
  checkCreditTopupLimits,
  type CreditTopupLimits,
  type CreditTopupLimitsCheck,
  creditTopupRefusal,
  DEFAULT_CREDIT_TOPUP_LIMITS,
  parseCreditTopupLimits,
  voiceTopupLimits,
} from "../../supabase/functions/_shared/checkout-pricing";
import { MODE_CREDIT_TOPUP } from "../../supabase/functions/_shared/payment-modes";

export {
  CREDIT_TOPUP_CAP_COP,
  CREDIT_TOPUP_MAX_PRESETS,
  checkCreditTopupLimits,
  type CreditTopupLimits,
  type CreditTopupLimitsCheck,
  creditTopupRefusal,
  DEFAULT_CREDIT_TOPUP_LIMITS,
  MODE_CREDIT_TOPUP,
  parseCreditTopupLimits,
  voiceTopupLimits,
};

export const CREDIT_TOPUP_DESCRIPTION = "Flow - Recarga de saldo";

export function parseCopInput(raw: string): number | null {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return null;
  const value = Number(digits);
  return Number.isSafeInteger(value) ? value : null;
}

export function parseCopListInput(raw: string): number[] | null {
  const parts = raw.split(/[,;\n]/).map((p) => p.trim()).filter((p) => p !== "");
  const values: number[] = [];
  for (const part of parts) {
    const cleaned = part.replace(/[$.\s]/g, "");
    if (!/^\d+$/.test(cleaned)) return null;
    values.push(Number(cleaned));
  }
  return values;
}

export function formatCopList(values: number[]): string {
  return values.map((v) => Math.round(v).toLocaleString("es-CO")).join(", ");
}

export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
